/**
 * The product name, read in one place. The owner has not chosen the name yet (PRD decision 39), so
 * it is set at build time: VITE_APP_NAME and VITE_APP_SHORT_NAME in web/.env (see .env.example).
 * Every screen, every i18n string ({{app}}), the PDF, the PWA manifest and the browser title use these.
 */
export const DEFAULT_APP_NAME = 'Village Savings'

/** Falls back to the default when a value is missing or only spaces. */
export function readName(value: unknown, fallback: string): string {
  return typeof value === 'string' && value.trim() !== '' ? value.trim() : fallback
}

export const APP_NAME = readName(import.meta.env.VITE_APP_NAME, DEFAULT_APP_NAME)
export const APP_SHORT_NAME = readName(import.meta.env.VITE_APP_SHORT_NAME, APP_NAME)

/** The mark's letter: the first letter or digit of the name, in capitals. */
export function brandLetter(name: string = APP_NAME): string {
  const first = Array.from(name.trim()).find((c) => /[\p{L}\p{N}]/u.test(c))
  return (first ?? 'V').toLocaleUpperCase('en')
}
